const enCommon = {
  nav: {
    home: 'Home',
    projects: 'Projects',
    services: 'Services',
    about: 'About',
    contact: 'Contact',
    login: 'Employee Login',
  },
  hero: {
    title: 'Building',
    titleSecond: 'Dreams in',
    titleThird: 'Tetouan',
    subtitle: 'Promotet is a leading real estate development company in Tetouan, Morocco, specializing in residential, commercial, and investment properties. We transform visions into reality with exceptional quality and innovative design.',
    cta: 'Explore Projects',
    stats: {
      projects: 'Completed Projects',
      years: 'Years of Excellence',
      clients: 'Satisfied Clients',
    },
  },
  projects: {
    label: 'Our Projects',
    title: 'Discover Our',
    titleSecond: 'Premium Developments',
    description: 'Explore our portfolio of exceptional real estate projects, each designed to offer luxury, comfort, and a superior lifestyle in prime locations.',
    compareProjects: 'Compare Projects',
    showFilters: 'Show Filters',
    hideFilters: 'Hide Filters',
    filterLocation: 'Location',
    filterBedrooms: 'Bedrooms',
    filterPrice: 'Price Range',
    allLocations: 'All Locations',
    allBedrooms: 'All Bedrooms',
    bedroom: 'Bedroom',
    bedrooms: 'Bedrooms',
    resetFilters: 'Reset Filters',
    projectsFound: 'projects found',
    noResults: 'No projects match your filters',
  },
  projectDetail: {
    backToProjects: 'Back to Projects',
    overview: {
      label: 'Project Overview',
      title: 'Luxury Living Redefined',
      description1: 'This exceptional development represents the pinnacle of modern luxury living in Tetouan. Combining contemporary architecture with premium finishes, every detail has been carefully crafted to provide residents with an unparalleled living experience.',
      description2: 'Located in one of the most sought-after areas, this project offers easy access to all amenities while providing a peaceful retreat from the bustling city. With world-class facilities and stunning views, this is more than just a home – it\'s a lifestyle.',
      scheduleVisit: 'Schedule a Visit',
      keyFeatures: 'Key Features',
    },
    features: {
      units: 'Units',
      size: 'Size Range',
      bedrooms: 'Bedrooms',
      parking: 'Parking',
      security: 'Security',
      delivery: 'Delivery',
      included: 'Included',
    },
    gallery: {
      label: 'Visual Tour',
      title: 'Explore the Spaces',
    },
    amenities: {
      label: 'Premium Amenities',
      title: 'World-Class Facilities',
      description: 'Enjoy an exceptional lifestyle with our comprehensive range of premium amenities designed for your comfort and convenience.',
      pool: 'Swimming Pool',
      gym: 'Fitness Center',
      garden: 'Landscaped Gardens',
      concierge: '24/7 Concierge',
      retail: 'Retail Spaces',
      playground: 'Kids Playground',
    },
    location: {
      label: 'Prime Location',
      title: 'Perfectly Positioned',
      description: 'Strategically located in the heart of Tetouan, offering easy access to schools, shopping centers, restaurants, and major transportation routes.',
    },
    cta: {
      title: 'Ready to Make This Your Home?',
      description: 'Contact our sales team today to schedule a private viewing and learn more about available units and payment plans.',
      contact: 'Contact Us',
      download: 'Download Brochure',
    },
  },
  services: {
    label: 'What We Offer',
    title: 'Comprehensive',
    titleSecond: 'Real Estate Solutions',
    description: 'From residential developments to commercial spaces and investment opportunities, we provide end-to-end real estate solutions tailored to your needs.',
    residential: {
      title: 'Residential Development',
      description: 'Creating modern living spaces that combine comfort, style, and functionality for families and individuals.',
      feature1: 'Luxury apartments and villas',
      feature2: 'Modern amenities and facilities',
      feature3: 'Prime locations in Tetouan',
      feature4: 'Sustainable design principles',
    },
    commercial: {
      title: 'Commercial Properties',
      description: 'Developing strategic commercial spaces designed to enhance business growth and customer experience.',
      feature1: 'Retail and office spaces',
      feature2: 'High-traffic locations',
      feature3: 'Flexible layouts',
      feature4: 'Modern infrastructure',
    },
    investment: {
      title: 'Investment Opportunities',
      description: 'Offering lucrative real estate investment options with strong returns and long-term value appreciation.',
      feature1: 'High ROI potential',
      feature2: 'Diverse portfolio options',
      feature3: 'Expert market analysis',
      feature4: 'Transparent processes',
    },
    process: {
      title: 'Our Development Process',
      step1: {
        title: 'Consultation',
        description: 'Understanding your needs and vision',
      },
      step2: {
        title: 'Planning',
        description: 'Detailed design and development strategy',
      },
      step3: {
        title: 'Construction',
        description: 'Quality execution with expert teams',
      },
      step4: {
        title: 'Delivery',
        description: 'Handover and ongoing support',
      },
    },
  },
  about: {
    label: 'About Promotet',
    title: 'Excellence in Real Estate Development',
    description: 'With over 15 years of experience, Promotet has established itself as a trusted name in Tetouan\'s real estate market. We are committed to creating exceptional properties that enhance communities and deliver lasting value.',
    number: '15',
    numberText: 'Years of transforming Tetouan\'s landscape with innovative real estate developments that set new standards for quality and design.',
    cta: 'Learn More',
    story: {
      title: 'Our Story',
      paragraph1: 'Founded in 2008, Promotet began with a simple vision: to transform Tetouan\'s real estate landscape through innovative design and exceptional quality. Over the years, we have grown from a small development firm to one of the region\'s most respected real estate companies.',
      paragraph2: 'Our success is built on a foundation of integrity, expertise, and a deep understanding of our clients\' needs. Every project we undertake reflects our commitment to excellence and our passion for creating spaces that enhance lives.',
    },
    mission: {
      title: 'Our Mission',
      paragraph1: 'We are dedicated to developing properties that not only meet the highest standards of quality and design but also contribute positively to the communities we serve. Our mission is to create sustainable, innovative spaces that stand the test of time.',
      paragraph2: 'Through careful planning, expert execution, and ongoing commitment to our clients, we strive to exceed expectations and deliver exceptional value in every project we undertake.',
    },
    values: {
      title: 'Our Core Values',
      value1: {
        title: 'Integrity',
        description: 'We conduct business with honesty, transparency, and ethical practices in every interaction.',
      },
      value2: {
        title: 'Innovation',
        description: 'We embrace new ideas and technologies to create cutting-edge real estate solutions.',
      },
      value3: {
        title: 'Excellence',
        description: 'We are committed to delivering the highest quality in every aspect of our work.',
      },
    },
  },
  testimonials: {
    label: 'Client Testimonials',
    title: 'What Our',
    titleSecond: 'Clients Say',
  },
  contact: {
    title: 'Get in Touch',
    subtitle: 'Ready to start your real estate journey? Contact us today to discuss your project or investment opportunity.',
    form: {
      title: 'Send us a Message',
    },
    name: 'Your Name',
    email: 'Email Address',
    phone: 'Phone Number',
    message: 'Your Message',
    submit: 'Send Message',
    sending: 'Sending...',
    success: 'Thank you! We will contact you soon.',
    error: 'Something went wrong. Please try again.',
    info: {
      title: 'Contact Information',
      address: 'Address',
      addressText: 'Avenue Mohammed V, Tetouan 93000, Morocco',
      phone: 'Phone',
      phoneText: '+212 539 123 456',
      email: 'Email',
      emailText: 'contact@promotet.ma',
    },
  },
  footer: {
    description: 'Your trusted partner in luxury real estate development across Belgium.',
    quickLinks: 'Quick Links',
    services: 'Services',
    contact: 'Contact Us',
    rights: 'All rights reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms & Conditions',
  },
  compare: {
    label: 'COMPARISON TOOL',
    title: 'Compare Projects',
    description: 'Select up to 3 projects to compare their features, pricing, and amenities side by side. Make an informed decision for your investment.',
    selectProjects: 'Select Projects to Compare',
    selectDescription: 'Choose up to 3 projects from our portfolio',
    comparison: 'Comparison',
    viewDetails: 'View Details',
    selectProject: 'Select Project',
    noProjects: 'No Projects Selected',
    noProjectsDescription: 'Please select at least one project from above to start comparing.',
    browseProjects: 'Browse All Projects',
    features: {
      price: 'Price Range',
      location: 'Location',
      units: 'Total Units',
      size: 'Unit Size',
      bedrooms: 'Bedrooms',
      parking: 'Parking',
      security: 'Security',
      delivery: 'Delivery',
      included: 'Included',
    },
  },
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last Updated: January 2025',
    intro: {
      title: 'Introduction',
      content: 'At LuxEstate, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.',
    },
    collect: {
      title: 'Information We Collect',
      content: 'We collect information that you provide directly to us, including:',
      item1: 'Personal identification information (name, email address, phone number)',
      item2: 'Property preferences and search criteria',
      item3: 'Communication records and correspondence',
      item4: 'Technical data such as IP address, browser type, and device information',
    },
    use: {
      title: 'How We Use Your Information',
      content: 'We use the information we collect to:',
      item1: 'Provide and improve our real estate services',
      item2: 'Communicate with you about properties and services',
      item3: 'Send you marketing communications (with your consent)',
      item4: 'Analyze website usage and improve user experience',
      item5: 'Comply with legal obligations and protect our rights',
    },
    protection: {
      title: 'Data Protection',
      content: 'We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.',
    },
    cookies: {
      title: 'Cookies and Tracking',
      content: 'We use cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, and personalize content. You can control cookie settings through your browser preferences.',
    },
    thirdParty: {
      title: 'Third-Party Services',
      content: 'We may share your information with trusted third-party service providers who assist us in operating our website and conducting our business. These parties are obligated to keep your information confidential and use it only for the purposes we specify.',
    },
    rights: {
      title: 'Your Rights',
      content: 'Under GDPR and applicable data protection laws, you have the right to:',
      item1: 'Access your personal data',
      item2: 'Correct inaccurate or incomplete data',
      item3: 'Request deletion of your data',
      item4: 'Object to or restrict processing of your data',
    },
    contact: {
      title: 'Contact Us',
      content: 'If you have any questions about this Privacy Policy or our data practices, please contact us:',
    },
  },
  terms: {
    title: 'Terms & Conditions',
    lastUpdated: 'Last Updated: January 2025',
    intro: {
      title: 'Introduction',
      content: 'Welcome to LuxEstate. These Terms and Conditions govern your use of our website and services. By accessing or using our website, you agree to be bound by these terms. If you do not agree with any part of these terms, please do not use our services.',
    },
    acceptance: {
      title: 'Acceptance of Terms',
      content: 'By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. Additionally, when using particular services, you shall be subject to any posted guidelines or rules applicable to such services.',
    },
    services: {
      title: 'Use of Services',
      content: 'You agree to use our services only for lawful purposes and in accordance with these Terms. You agree not to:',
      item1: 'Use the services in any way that violates any applicable law or regulation',
      item2: 'Engage in any conduct that restricts or inhibits anyone\'s use of the services',
      item3: 'Attempt to gain unauthorized access to any portion of the website',
      item4: 'Use any automated system to access the services in a manner that sends more requests than a human can reasonably produce',
    },
    property: {
      title: 'Property Information',
      content: 'All property information, images, and descriptions provided on this website are for informational purposes only. While we strive to ensure accuracy, we do not guarantee that all information is complete, accurate, or up-to-date. Property availability and pricing are subject to change without notice.',
    },
    intellectual: {
      title: 'Intellectual Property',
      content: 'The content on this website, including text, graphics, logos, images, and software, is the property of LuxEstate or its content suppliers and is protected by international copyright laws. You may not reproduce, distribute, or create derivative works without our express written permission.',
    },
    liability: {
      title: 'Limitation of Liability',
      content: 'LuxEstate shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the services. Our total liability shall not exceed the amount paid by you, if any, for accessing our services.',
    },
    indemnification: {
      title: 'Indemnification',
      content: 'You agree to indemnify and hold harmless LuxEstate and its affiliates, officers, agents, and employees from any claim or demand, including reasonable attorneys\' fees, made by any third party due to or arising out of your breach of these Terms or your violation of any law or rights of a third party.',
    },
    modifications: {
      title: 'Modifications to Terms',
      content: 'We reserve the right to modify these Terms at any time. We will notify you of any changes by posting the new Terms on this page and updating the "Last Updated" date. Your continued use of the services after such modifications constitutes your acceptance of the updated Terms.',
    },
    law: {
      title: 'Governing Law',
      content: 'These Terms shall be governed by and construed in accordance with the laws of Belgium, without regard to its conflict of law provisions. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts of Brussels, Belgium.',
    },
    contact: {
      title: 'Contact Information',
      content: 'If you have any questions about these Terms and Conditions, please contact us:',
    },
  },
};

export default enCommon;
